/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import baseGlobal from '@salesforce/retail-react-app/app/theme/foundations/styles';

import {markupStyles} from '@amblique/base/app/theme/global/markup';

export default {
  global: {
    ...baseGlobal.global,
    ...markupStyles,
  },
};
